var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const ArrowUp = (_a) => {
    var { color = 'white', width = 24, height = 24, fillOpacity = '1' } = _a, props = __rest(_a, ["color", "width", "height", "fillOpacity"]);
    return (React.createElement("svg", Object.assign({ width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M2.5 12C2.5 6.75614 6.75614 2.5 12 2.5C17.2439 2.5 21.5 6.75614 21.5 12C21.5 17.2439 17.2439 21.5 12 21.5C6.75614 21.5 2.5 17.2439 2.5 12ZM15 12.75C15.3155 12.75 15.6348 12.6323 15.8836 12.3836C16.3688 11.8983 16.3688 11.1017 15.8836 10.6164L12.8836 7.61645C12.3983 7.13118 11.6017 7.13118 11.1164 7.61645L8.11645 10.6164C7.63118 11.1017 7.63118 11.8983 8.11645 12.3836C8.60171 12.8688 9.39829 12.8688 9.88355 12.3836L10.75 11.5171V15.5C10.75 16.1861 11.3139 16.75 12 16.75C12.6861 16.75 13.25 16.1861 13.25 15.5V11.5171L14.1164 12.3836C14.3652 12.6323 14.6845 12.75 15 12.75Z", fill: "white", stroke: color })));
};
export default ArrowUp;
